import firebase from 'firebase/app';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import asContent from '../../hoc/asContent';
import {
  HandleFirebaseErrorResult,
  handleSignInWithEmailAndPasswordErrorCode,
} from '../../lib/firebase/firebaseErrorHandlers';
import { appActions } from '../../redux/actions/appActions';
import LoginView from './LoginView';

export const onCheckStoreIdentity = (checked: boolean): void => {
  const persistence = checked
    ? firebase.auth.Auth.Persistence.LOCAL
    : firebase.auth.Auth.Persistence.SESSION;

  firebase
    .auth()
    .setPersistence(persistence)
    .then(() => {
      return;
    });
};

interface LoginProps {}
const Login: React.FC<LoginProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [error, setError] =
    React.useState<HandleFirebaseErrorResult | null>(null);

  const toPWReset = React.useCallback(() => {
    history.push('/password-reset');
  }, [history]);

  const onLogin = React.useCallback(
    (email: string, pw: string) => {
      dispatch(appActions.setLoadingState({ visible: true }));

      firebase
        .auth()
        .signInWithEmailAndPassword(email, pw)
        .then(() => {
          dispatch(appActions.setLoadingState({ visible: false }));
        })
        .catch(error => {
          dispatch(appActions.setLoadingState({ visible: false }));

          setError(handleSignInWithEmailAndPasswordErrorCode(error.code));
        });
    },
    [dispatch]
  );

  return (
    <LoginView
      onLogin={onLogin}
      toPWReset={toPWReset}
      onCheckStoreIdentity={onCheckStoreIdentity}
      error={error}
    />
  );
};

export default asContent(Login);
